import React from 'react';
import { Page, Text, View, StyleSheet } from '@react-pdf/renderer';
import { style } from '../../../components/pdf/fontstyles';

const tableStyles = StyleSheet.create({
  table: {
    width: '100%',
    marginTop: 15,
    marginBottom: 15,
    border: '1px solid #000',
  },
  tableRow: {
    flexDirection: 'row',
    minHeight: 30,
  },
  // Header row styles
  headerRow: {
    backgroundColor: '#f0f0f0',
    fontWeight: 'bold',
  },
  // Main header cells
  mainHeaderCell: {
    padding: 5,
    borderRight: '1px solid #000',
    borderBottom: '1px solid #000',
    textAlign: 'center',
    fontSize: 10,
  },
  // Sub-header cells
  subHeaderCell: {
    padding: 5,
    borderRight: '1px solid #000',
    textAlign: 'center',
    fontSize: 9,
    borderBottom: '1px solid #000',
  },
  // Regular cells
  tableCell: {
    padding: 5,
    borderRight: '1px solid #000',
    borderBottom: '1px solid #000',
    fontSize: 9,
    textAlign: 'center',
  },
  // Column width styles
  colPeriod: { width: '15%' },
  colTotal: { width: '10%' },
  colEnjoyed: { width: '15%' },
  colRemarks: { width: '20%' },
});

const VacationPeriods = ({result}) => (
  <View size="A4" style={style.page}>
    {/* Header */}
    <View>
      <Text style={[style.subtitle, style.ArialBold]}>
        Pension Scheme for the Teaching Staff in Non-Government Secondary Schools
      </Text>
      <Text style={[style.subtitle, style.ArialBold]}>
        (vide G.R.E. & S.W.D.NO. SSN356-6, dated 4th November 1968)
      </Text>
    </View>

    <Text style={[style.title, style.ArialBlack]}>
      Statement of Periods of Vacations
    </Text>
    <View style={style.solidLine}/>

    {/* Subject Line */}
    <Text style={[style.paragraph, {marginBottom: 10}]}>
      Statement showing the period of vacations enjoyed by {result.employeeName}, {result.designation}, {result.institutionName}
    </Text>

{/* Vacation Table */}
    <View style={tableStyles.table}>
      {/* First Header Row */}
      <View style={[tableStyles.tableRow, tableStyles.headerRow]}>
        <View style={[tableStyles.mainHeaderCell, tableStyles.colPeriod, {width: '30%'}]}>
          <Text>Period of Vacation</Text>
        </View>
        <View style={[tableStyles.mainHeaderCell, tableStyles.colTotal]}>
          <Text>Total Period</Text>
        </View>
        <View style={[tableStyles.mainHeaderCell, tableStyles.colEnjoyed, {width: '30%'}]}>
          <Text>Period of Vacations enjoyed</Text>
        </View>
        <View style={[tableStyles.mainHeaderCell, tableStyles.colTotal]}>
          <Text>Total Period</Text>
        </View>
        <View style={[tableStyles.mainHeaderCell, tableStyles.colRemarks, {borderRight: 'none'}]}>
          <Text>Remarks</Text>
        </View>
      </View>

      {/* Second Header Row (sub-headers) */}
      <View style={[tableStyles.tableRow, tableStyles.headerRow]}>
        <View style={[tableStyles.subHeaderCell, tableStyles.colPeriod]}>
          <Text>From</Text>
        </View>
        <View style={[tableStyles.subHeaderCell, tableStyles.colPeriod, {borderRight: '1px solid #000'}]}>
          <Text>To</Text>
        </View>
        <View style={[tableStyles.subHeaderCell, {width: '10%'}]}></View>
        <View style={[tableStyles.subHeaderCell, tableStyles.colEnjoyed]}>
          <Text>From</Text>
        </View>
        <View style={[tableStyles.subHeaderCell, tableStyles.colEnjoyed, {borderRight: '1px solid #000'}]}>
          <Text>To</Text>
        </View>
        <View style={[tableStyles.subHeaderCell, {width: '10%'}]}></View>
        <View style={[tableStyles.subHeaderCell, tableStyles.colRemarks, {borderRight: 'none'}]}></View>
      </View>

      {/* Data Row */}
      <View style={tableStyles.tableRow}>
        <View style={[tableStyles.tableCell, tableStyles.colPeriod]}></View>
        <View style={[tableStyles.tableCell, tableStyles.colPeriod]}></View>
        <View style={[tableStyles.tableCell, tableStyles.colTotal]}></View>
        <View style={[tableStyles.tableCell, tableStyles.colEnjoyed]}>
          <Text>{result.dateOfAppointment}</Text>
        </View>
        <View style={[tableStyles.tableCell, tableStyles.colEnjoyed]}>
          <Text>{result.dateOfRetirement}</Text>
        </View>
        <View style={[tableStyles.tableCell, tableStyles.colTotal]}></View>
        <View style={[tableStyles.tableCell, tableStyles.colRemarks, {borderRight: 'none'}]}>
          <Text>All vacations are enjoyed</Text>
        </View>
      </View>
    </View>
    {/* End of Vacation Table */}
    <Text style={[style.paragraph, {marginBottom: 10, fontSize: 8 , marginTop:0}]}>w.e.f.          no vacations are enjoyed.</Text>
    {/* Certification Paragraphs */}
    <View style={[style.paragraph, {marginTop: 10}]}>
      <Text>1) {result.employeeName}, {result.designation}, enjoyed all the vacations and never detained for official duties during his/her entire service from {result.dateOfAppointment} to {result.dateOfRetirement}.</Text>
      <Text>2) {result.employeeName} joined service as {result.designation} in this school w.e.f. {result.dateOfAppointment} and opted for revised pension Rules 1950 only and never opted Old Pension Rules which were in force prior to 1.4.50.</Text>
      <Text>3) Vacations enjoyed by the teacher serving in vacation department after 1.4.1936 are treated as duty for counting qualifying service as per Rule 41 (3) of B.C.S.R. Vol/II as such the question of filling this form does not arise.</Text>
    </View>

    {/* Signature Section */}
    <View style={[style.paragraph, {marginTop: 20}]}>
      <Text>Place: {result.placeOfRetirement}</Text>
      <Text>Date:</Text>
    </View>
    <Text style={style.signature}>Head Master</Text>

    <Text style={style.paragraph}>Countersigned by:</Text>
    <Text style={style.paragraph}>Education Officer, Zilla Parishad, {result.educationOfficer}</Text>
  </View>
);

export default VacationPeriods;